<script lang="ts" setup>
withDefaults(
  defineProps<{
    count?: number
    active?: boolean
  }>(),
  {
    count: 0,
    active: false,
  },
)
</script>
<template>
  <ButtonBase :class="['taxonomy-toggle', 'label', { active }]">
    <template #before>
      <Badge v-if="count">{{ count }}</Badge>
    </template>
    <slot />
    <template #after>
      <Icon v-if="active" name="mini-minus-small" />
      <Icon v-else name="mini-plus-small" />
    </template>
  </ButtonBase>
</template>

<style lang="scss" scoped>
.taxonomy-toggle {
  --pv: 12px;
  --ph: 24px;
  --icon-size: 12px;
  --gap: 8px;

  line-height: 0;
  height: 50px;

  :deep(.text) {
    display: inline-flex;
    align-items: center;
    gap: var(--gap);
  }

  &.active {
    :deep(.background) {
      border-width: 2px;
      border-color: var(--color-border-hover);
      background-color: var(--color-background-hover);
      transform: scale(1);
    }
  }

  .badge {
    --size: 26px;
    --color: var(--c-primary);
    --background: var(--c-background-light);
  }
}
</style>
